<template>
  <div>
    <div @click="$emit('click:outer')">
      <v-overlay :value="open" />
    </div>
    <v-sheet :style="style">
      <slot />
    </v-sheet>
  </div>
</template>

<script>
export default {
  name: "SlidePanel",
  props: {
    open: {
      type: Boolean
    },
    width: {
      type: String
    },
    paddingTop: {
      type: String
    }
  },
  destroyed() {
    document.documentElement.style.overflow = "auto"
  },
  computed: {
    style() {
      return {
        position: "fixed",
        top: this.paddingTop || 0,
        left: this.open ? `calc(100% - ${this.width})` : '100%',
        right: this.open ? 0 : `-${this.width}`,
        height: '100vh',
        backgroundColor: '#F7FAFE',
        zIndex: 1000,
        transition: 'all .3s ease-in-out'
      }
    }
  },
  watch: {
    open: {
      handler(value) {
        if (value) {
          document.documentElement.style.overflow = "hidden"
        } else {
          document.documentElement.style.overflow = "auto"
        }
      }
    }
  }
}
</script>

<style scoped>

</style>